export default function ($translateProvider) {
	'ngInject';

	$translateProvider
		.translations('bg', {
			'OFFICE': {
				'LABEL': 'Офиси',
				'PHONE': 'Телефони:',
				'ADDRESSES': {
					'SOFIA': 'София, Автобусна спирака  Trafik Market, офис 87',
					'BUDAPEST': 'Будапеща, автобусна спирка Nepliget, сектор 5',
					'BRATISLAVA': 'Братислава, автобусна спирка Mlinski Nivi, сектор 14',
					'BRNO': 'Бърно, автобусна спирка Zvonarka, сектор 38',
					'PRAHA': 'Прага, автобусна спирка Florenc, сектор 9'
				}
			}
		})
		.translations('en', {
			'OFFICE': {
				'LABEL': 'Office',
				'PHONE': 'Phone numbers:',
				'ADDRESSES': {
					'SOFIA': 'Sofia, Bus station Traffic Market, office 87',
					'BUDAPEST': 'Budapest, Bus station Nepliget, Sector 5',
					'BRATISLAVA': 'Bratislava, Bus station Mlinski Nivi, Sector 14',
					'BRNO': 'Brno, Bus station Zvonarka, Sector 38',
					'PRAHA': 'Praha, Bus station Florenc, Sector 9'
				}
			}
		})
		.translations('cz', {
			'OFFICE': {
				'LABEL': 'Kanceláře',
				'PHONE': 'Тelefony:',
				'ADDRESSES': {
					'SOFIA': 'Sofia, Bus station Traffic Market, office 87',
					'BUDAPEST': 'Budapest, Bus station Nepliget, Sector 5',
					'BRATISLAVA': 'Bratislava, Bus station Mlinski Nivi, Sector 14',
					'BRNO': 'Brno, Bus station Zvonarka, Sector 38',
					'PRAHA': 'Praha, Bus station Florenc, Sector 9'
				}
			}
		})
		.translations('hu', {
			'OFFICE': {
				'LABEL': 'Irodák',
				'PHONE': 'Тelefonok:',
				'ADDRESSES': {
					'SOFIA': 'Sofia, Bus station Traffic Market, office 87',
					'BUDAPEST': 'Budapest, Bus station Nepliget, Sector 5',
					'BRATISLAVA': 'Bratislava, Bus station Mlinski Nivi, Sector 14',
					'BRNO': 'Brno, Bus station Zvonarka, Sector 38',
					'PRAHA': 'Praha, Bus station Florenc, Sector 9'
				}
			}
		});
}



/** WEBPACK FOOTER **
 ** ./client/public/main/offices/offices.locale.js
 **/